// PDF.js is served from our own origin rather than cdnjs. The CDN copy was pinned at 2.10.377
// (Oct 2021), which predates the fix for the malicious-PDF arbitrary-script-execution class
// (CVE-2024-4367, fixed in 4.2.67) -- and patient-uploaded PDFs are rendered in a provider's
// authenticated browser, so that path mattered here.
//
// The legacy build is used deliberately: it carries the wider browser baseline needed by the
// iOS and Android webviews, which the default build does not target.
import * as pdfjsLib from 'pdfjs-dist/legacy/build/pdf.mjs';

// v4+ requires an explicit worker; there is no main-thread fallback to silently rely on.
// new URL(..., import.meta.url) makes webpack emit the worker as its own asset and rewrite
// this to the hashed public/ path, so the worker is same-origin and satisfies CSP 'self'.
// .href is required, not optional: the setter is `if(typeof val !== "string") throw` and webpack
// leaves the expression as a real URL object, so assigning it directly threw on every page load.
pdfjsLib.GlobalWorkerOptions.workerSrc = new URL(
  'pdfjs-dist/legacy/build/pdf.worker.min.mjs',
  import.meta.url
).href;

// the two call sites (make_pdf_work, media_editor_load_pdf) read a global, not a module import,
// so keep exposing the same name they already guard on with `typeof pdfjsLib === 'undefined'`
window.pdfjsLib = pdfjsLib;
